import React from 'react'
import '../stylesheets/new_button.sass'
import { NavLink } from 'react-router-dom'

export const NewButton = (props) => {
  return(
    <NavLink className={'new_button'} to={props.link}>
      <div>
        + New
      </div>
    </NavLink>
  )
}




// WEBPACK FOOTER //
// ./src/shared/NewButton.jsx